
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent4 as ObiWindApparent4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-4.js';
 
 
 

 
 export const ObiWindApparent4 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-4',
   elementClass: ObiWindApparent4Element,
   events: {
     
   }
  });
 
 